/**
 * @file:
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/7/10      1.0     First version
 * 2024/10/14      2.0     Second version 原DOP首页改为我的待办页，增菜单跳转
 *
 * Copyright 2021-2023, all rights reserved. Essa.cn
 * */
import React,{Fragment,PureComponent} from "react";
import Lang from "@/components/Lang/Lang";
import dayjs from 'dayjs';
import { Radio,Spin } from "antd";
import SearchForm from '@components/SearchForm/SearchForm';
import ToDo from "./components/todo/ToDo";
import DopIndexAction from "./dopIndex.action";
import Remind from "./components/remind/Remind";
import _ from "lodash";
import {isEmpty} from "@utils/utils";
import ChartFunnel from "./components/ChartFunnel";
import ChartSankey from "./components/ChartSankey";
import CalendarFollowUpMatters from "./components/calendarFollowUpMatters/CalendarFollowUpMatters";
import ReactContext from "@store/reactContext";
import "./dopIndex.less";


const RadioGroup = Radio.Group;
export default class MyToDoList  extends PureComponent {
    static contextType = ReactContext;
    constructor(props,context) {
        super(props)
        this.state = {
            optionsDays : [
                { label:Lang({id:"YongHuXingWei2",default:"近60天"}), value: '-1',  },
                { label:Lang({id:"ShangYue",default:"上月"}), value: '1',  },
                { label:Lang({id:"BenYue",default:"本月"}), value: '2',  },
            ],
            searchObj:{
                days:"-1"
            }
        }
        this.getFormData = _.debounce(this.getFormData, 1000);  //避免search方法被多次不停的调用
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /*
    * 配置不可选择日期
    * 最多统计365天。只能选择今天和之前的日期
    * */
    disabledDate(current) {
        if( current && current > dayjs().endOf('day')) return true;
        // if( current && current < dayjs().subtract(1, 'year').startOf('day'))  return true;
        return false;
    }
    /**
     * 搜索
     ***/
    getFormData(values={}) {
        const { searchObj={}} = this.state;
        let newObj = {...searchObj,...values}
        if(values.startTimeB){
            delete newObj.days;
            newObj["startTime"] = values.startTimeB;
            newObj["endTime"] = values.endTimeB;
            delete newObj.startTimeB;
            delete newObj.endTimeB;
        }
        this.setState({
            searchObj:newObj
        },()=>this.fetchBoard(newObj));
    }
    /**
     * 搜索 http://rap.essa.top:88/workspace/myWorkspace.do?projectId=211#8309
     * @param pageIndex 页码
     * @param fetchBoardCondition 条件
     */
    fetchBoard(searchObj){
        this.loading(true);
        // const {searchObj={}} = this.state;
        // 处理 空值
        for(let key in searchObj){
            if(isEmpty(searchObj[key])){
                delete searchObj[key];
            }
        }
        DopIndexAction.postHttpAction("/service/mg/home/conversion/rate",searchObj).then((resp)=>this.handleRes(resp.data,searchObj)).catch(err=>this.handleRes(err));
        DopIndexAction.postHttpAction("/service/mg/home/sankey",searchObj).then((resp)=>this.handleSankeyRes(resp.data,searchObj)).catch(err=>this.handleSankeyRes(err));
    }
    handleRes(res={},newObj={}){
        this.loading(false)
        const {success,valid,models=[] }= res;
        let { boardModel={} } = this.state;
        boardModel["funnelList"] = models;
        if(success&&valid){
            this.setState({
                boardModel: boardModel,
                searchObj:newObj,
                reloadFunnel:true,
            },()=>{
                this.setState({
                    reloadFunnel:false,
                })
            })
        }
    }
    handleSankeyRes(res={},newObj={}){
        this.loading(false)
        const {success,valid,models=[] }= res;
        let { boardModel={} } = this.state;
        boardModel["sankeyList"] = models;
        if(success&&valid){
            // this.setState({
            //     searchObj:newObj
            // }
            this.setState({
                boardModel: boardModel,
                searchObj:newObj,
                reloadSankey:true,
            },()=>{
                this.setState({
                    reloadSankey:false,
                })
            })
        }
    }
    /*
    * @code : days 转化看板 时间范围
    * */
    changeValue(code,value){
        this.loading(true);
        try {
            const { searchObj={}} = this.state;
            let newObj = {...searchObj};
            if(code=="days"){
                let iStartTime=0, iEndTime=0;
                if(value=="-1"){//近60天
                    iStartTime  = dayjs().subtract(60, 'days').startOf('day').valueOf();//60天前开始 时间
                    iEndTime = dayjs().valueOf();//今天 结束时间
                }
                if(value=="1"){//上月
                    iStartTime  = dayjs().subtract(1, 'month').startOf('month').valueOf();// 开始 时间
                    iEndTime = dayjs().subtract(1, 'month').endOf('month').valueOf();//  结束时间
                }
                if(value=="2"){//本月
                    iStartTime  = dayjs().startOf('month').valueOf();// 开始 时间
                    iEndTime = dayjs().endOf('month').valueOf();//  结束时间
                }
                newObj["startTime"] = iStartTime;
                newObj["endTime"] = iEndTime;
                if(this.onRefSearchChrld){
                    this.onRefSearchChrld.setField("times",null);//清空时间范围
                    this.onRefSearchChrld.setField("startTimeB",null);//清空时间范围
                    this.onRefSearchChrld.setField("endTimeB",null);//清空时间范围
                }
            }
           newObj[code] = value;
           this.getFormData(newObj);
        }catch (e) {
            this.loading(false);
        }
    }

    onRefSearch = (ref) =>  this.onRefSearchChrld = ref;
    componentWillMount() {
        this.changeValue("days","-1");
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { optionsDays,searchObj={},boardModel={},loading=true,reloadFunnel=true,reloadSankey=true } = this.state;
        const { context={} } = this;
        const _extraState = context._extraState||{};
        const positionCode = _extraState.positionCode||"";
        // 0 销售经理（全），1 业务员 (注册客户—待办+新客图例)，2 客服 (已成交客户—待办+已成交客户图例)，3 会计， 4 清关，5 仓管，6 商品经理，7 管理员（全）
        const hadPermi = positionCode === "0"||positionCode==="1"||positionCode=== "2" || positionCode=== "7";
        const newPermi =  positionCode=== "0"||positionCode=== "1"|| positionCode=== "7";
        const orderPermi =  positionCode=== "0" ||positionCode=== "2" || positionCode=== "7";
        return (hadPermi?<Spin spinning={loading}>
            <div className="dopIndexWrap black89 font_14 flex-item">
                <div className={"left flex-1"}>
                    {/* 已成交客户待办 -> 屏蔽业务员  */}
                    {orderPermi?<div className={"commonBox pinkBox mb_16"}>
                       <ToDo />
                    </div>:null}
                    {/* 注册客户待办 -> 屏蔽 客服 */}
                    {newPermi?<div className={"commonBox blueBox mb_16"}>
                        <Remind />
                    </div>:null}
                    <div className={"commonBox borderBox mb_16"}>
                        <div className={"font_18 fw_500 lineH_27"}>{Lang({ id: "ZhuanHuaLvKanBan", default:'转化率看板' })}</div>
                        <div className={"black45 lineH_21"}>{Lang({ id: "ZhiYouLuoZaiShiJianFanWei", default:'只有落在时间范围内的数据才会被统计到' })}</div>
                        <div className={"searchBar mt_16"}>
                            <SearchForm
                                onRef={this.onRefSearch}
                                options = {[
                                    {
                                        name:'times',
                                        type:'DateRangePicker',
                                        cnPlaceholder:['开始时间','结束时间'],
                                        cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                                        canSearch:true,
                                        searchRange:['startTimeB','endTimeB'],
                                        allowClear:false,
                                        width:332,
                                        disabledDate: this.disabledDate.bind(this),
                                    },
                                    {
                                        name:'promoteModeId',
                                        cnTitle:'',
                                        cnTitleId:'',
                                        cnPlaceholder:'全部注册渠道',
                                        cnPlaceholderId:'QuanBuZhuCeQuDao',
                                        width:350,
                                        type:"SearchSelect",
                                        canSearch:true,
                                        searchClass:{
                                            api:"/service/mg/follower/search/channel",
                                        },
                                    },
                                    (positionCode==="0"||positionCode==="7")?{
                                        name:'foreignUserId',
                                        cnTitle:'',
                                        cnTitleId:'',
                                        cnPlaceholder:'全部跟进人', // 只有 销售经理和管理员才能用
                                        cnPlaceholderId:'QuanBuGenJinRen',
                                        width:380,
                                        type:"SearchSelect",
                                        canSearch:true,
                                        searchClass:{
                                            api:"/service/mg/follower/search/foreign",
                                        },
                                    }:null,
                                ]}
                                searchLeft={<RadioGroup className={"mr_8 mb_10"}
                                                        options={optionsDays}
                                                        onChange={(e)=>this.changeValue("days",e.target.value)} value={searchObj.days} optionType="button" />}
                                flagShowReset={false}
                                flagShowSearchBtn={false}
                                getSearchValue={this.getFormData.bind(this)} />
                        </div>
                        <div className={"mt_6"}>
                            {/*  业务员 1(注册客户—待办+新客图例) */}
                            {newPermi?<div className={"lineBox"}>
                                <div className={"font_18 fw_500 lineH_27"}>{Lang({ id: "XinKe", default:'新客' })}</div>
                                {!reloadFunnel?<ChartFunnel funnelList={boardModel.funnelList||[]} />:null}
                            </div>:null}
                            {/*  客服 2 (已成交客户—待办+已成交客户图例) */}
                            {orderPermi?<div className={"lineBox"}>
                                <div className={"font_18 fw_500 lineH_27"}>{Lang({ id: "YiChengJiaoKeHu", default:'成交客户' })}</div>
                                {!reloadSankey?<ChartSankey sankeyList={boardModel.sankeyList||[]} />:null}
                            </div>:null}
                        </div>
                    </div>
                </div>
                <div className={"rightDealt commonBox ml_14"}>
                    <CalendarFollowUpMatters />
                </div>
            </div>
        </Spin>:<div className="black89 pt_40 text-center">
            <img src={"https://oss.essaone.com/ba0bc74b-252d-4cba-82b1-f887c57f93fb.jpg"} />
        </div>);
    }
}